<template>
  <v-row>
    <v-col class="wpaper"></v-col>
    <v-col cols="3" class="login d-flex align-center flex-column justify-space-between">
      <img src="/smartchronos2.svg" class="sc-logo" />
      <div class="container">
        <v-form>
          <v-text-field label="Nombre de usuario" dark outlined v-model="account.usr" dense></v-text-field>
          <v-text-field label="Contraseña" dark outlined v-model="account.password" dense></v-text-field>
          <v-select label="Ingresar como" :items="opciones" v-model="account.mode" dark outlined dense></v-select>
          <div class="text-right">
            <v-btn color="primary">Ingresar</v-btn>
          </div>
        </v-form>
      </div>
      <img
        class="vt-logo"
        src="http://45.33.113.68/wp-content/uploads/2019/04/Logo-Vertebra-final.png"
        alt
      />
    </v-col>
  </v-row>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  data: () => ({
    opciones: ["CLIENTE", "VERTEBRA"],
    account: {}
  }),
  created() {
    this.account.mode = "CLIENTE";
  }
});
</script>

<style lang="scss" scoped>
.login {
  border-left: 1px solid rgba(#000, 0.1);
  position: relative;
  overflow: hidden;
  // background: #34495e;
  background: #009432;
  .vt-logo {
    width: 100%;
  }
  .sc-logo {
    width:100%;
  }
}

.wpaper {
  background: url("~@/assets/earth.jpg");
  background-size: cover;
}
</style>